export default __webpack_public_path__ + "877ebdf865ab8e1874e42fc4f37474f1.png";